import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

export let slider = {
    selectorSlider: ".ui-slider",
    sliders: [],
    settings: {
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 2000,
        },
        modules: [Autoplay, Navigation, Pagination],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".slider__pagination",
            clickable: true,
        },
    },

    bind: function (selectorSlider = this.selectorSlider, settings = this.settings, delay = true) {

        const selectors = document.querySelectorAll(selectorSlider);
        
        if (selectors == null) return;
        
        selectors.forEach((slider, index) => {
            let swiper = this.init(slider, settings, true);

            if(delay) {
                // Pause autoplay initially
                swiper.autoplay.stop();

                // Start autoplay with staggered initial delay
                setTimeout(() => {
                    swiper.autoplay.start();
                }, 2000 + index * 1000); // First slider at 2s, second at 2.5s, third at 3s, etc.
            }
        });
    },

    /**
     * Initializes single Swiper instance
     */
    init: function (selectorSlider = this.selectorSlider, settingsCustom = {}, returnInstance = false) {
        let settingsDefault = this.settings;

        let settings = { ...settingsDefault, ...settingsCustom };
        console.log(settings);
        let instance = new Swiper(selectorSlider, settings);
        if (returnInstance) return instance;
    },
};
